var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.organizationInfo && _vm.organizationInfo.logo)?_c('div',{attrs:{"id":"organization_logo"}},[_c('img',{attrs:{"src":_vm.organizationInfo.logo,"title":_vm.organizationInfo.name}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }